import Vue from "vue";
import Vuex from "vuex";
import others from "./others";
import widgetData from "./widget-data";
import fakeLeads from "./fake-leads";
import calculateLeads from "./calculate-leads";

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        fakeLeads,
        others,
        widgetData,
        calculateLeads
    }
});
